<template lang='pug'>
  i.svg-icon.svg-icon-write
    svg(
      :fill='color'
      :width='`${size}px`'
      :height='`${size}px`'
      viewBox='0 0 100 100'
    )
      path(d='M3.771,96.371l24.938-2.58L6.352,71.433L3.771,96.371z M59.254,18.532l22.355,22.357L33.008,89.491 L10.65,67.135L59.254,18.532z M93.159,29.339c4.093-4.092,4.095-10.728,0-14.821l-7.534-7.536c-4.093-4.093-10.729-4.092-14.823,0 l-7.289,7.291L85.87,36.629L93.159,29.339z M36.236,20.07h-9.901c-0.322,0-0.583-0.261-0.583-0.583V9.585 c0-1.608-1.304-2.912-2.912-2.912s-2.912,1.303-2.912,2.912v9.902c0,0.321-0.262,0.583-0.583,0.583H9.444 c-1.608,0-2.912,1.304-2.912,2.912c0,1.609,1.304,2.912,2.912,2.912h9.902c0.321,0,0.583,0.261,0.583,0.583v9.901 c0,1.609,1.303,2.912,2.912,2.912s2.912-1.303,2.912-2.912v-9.901c0-0.322,0.261-0.583,0.583-0.583h9.901 c1.609,0,2.912-1.303,2.912-2.912C39.148,21.374,37.845,20.07,36.236,20.07z')

</template>

<script>
export default {

  props: {
    size: {
      type: Number,
      default: 20,
    },
    color: {
      type: String,
      default: '#333',
    },
  },

}
</script>